import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function VoucherBookPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const pickupLocations = [
    { name: 'Skegness', icon: 'ri-map-pin-line', color: 'text-orange-500' },
    { name: 'Mablethorpe', icon: 'ri-map-pin-line', color: 'text-teal-500' },
    { name: 'Chapel St Leonards', icon: 'ri-map-pin-line', color: 'text-cyan-500' },
    { name: 'Ingoldmells', icon: 'ri-map-pin-line', color: 'text-green-500' },
    { name: 'Sutton on Sea', icon: 'ri-map-pin-line', color: 'text-amber-500' },
    { name: 'Sandilands', icon: 'ri-map-pin-line', color: 'text-pink-500' }
  ];

  const categories = [
    { icon: 'ri-ticket-line', title: 'Attractions', color: 'bg-orange-100 text-orange-600', desc: 'Theme parks, zoos, wildlife parks' },
    { icon: 'ri-restaurant-line', title: 'Dining', color: 'bg-green-100 text-green-600', desc: 'Restaurants, cafes, pubs' },
    { icon: 'ri-hotel-line', title: 'Accommodation', color: 'bg-cyan-100 text-cyan-600', desc: 'Hotels, caravan parks, camping' },
    { icon: 'ri-movie-line', title: 'Entertainment', color: 'bg-pink-100 text-pink-600', desc: 'Cinemas, arcades, shows' },
    { icon: 'ri-shopping-bag-line', title: 'Shopping', color: 'bg-teal-100 text-teal-600', desc: 'Local shops, boutiques, gifts' },
    { icon: 'ri-sun-line', title: 'Activities', color: 'bg-amber-100 text-amber-600', desc: 'Beach activities, sports, tours' }
  ];

  const benefits = [
    {
      icon: 'ri-book-open-line',
      title: 'Physical Voucher Book',
      desc: 'Traditional printed voucher book you can carry with you everywhere'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Dozens of Exclusive Offers',
      desc: 'Save money at top attractions, restaurants, and shops along the coast'
    },
    {
      icon: 'ri-repeat-line',
      title: 'Many Exclusive offers inside',
      desc: 'Even if you have our App on your phone, make sure you grab a copy of the book'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Completely FREE',
      desc: 'Pick up your free copy at participating locations - no cost, no subscription'
    },
    {
      icon: 'ri-group-line',
      title: 'Family Friendly',
      desc: 'Perfect for families looking to maximize their holiday budget'
    },
    {
      icon: 'ri-calendar-line',
      title: 'Available from Easter',
      desc: 'Distribution starts at Easter 2026 at locations across the Lincolnshire coast'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white shadow-md'}`}>
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3 transform transition-transform duration-300 hover:scale-105">
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/659671df2896ffc0ce475e0437197503.png" 
                alt="Seaside Vouchers" 
                className="h-16 w-16"
              />
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/e0d98287e8c9dc8abdecc58291257ecc.png" 
                alt="SEASIDE VOUCHERS" 
                className="h-12"
              />
            </div>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Home</Link>
              <Link to="/how-it-works" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">How it works</Link>
              <Link to="/seaside-offers" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Seaside Vouchers App</Link>
              <Link to="/voucher-book" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Voucher Book</Link>
              <Link to="/leisure-home-sales" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Leisure Home Sales</Link>
              <Link to="/accommodation" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Accommodation</Link>
              <Link to="/contact" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Contact us</Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-28 pb-8 bg-gradient-to-br from-cyan-400 to-cyan-500 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-10 left-10 w-64 h-64 bg-teal-300 rounded-full opacity-20 blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-20 w-80 h-80 bg-orange-300 rounded-full opacity-20 blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-1/2 left-1/3 w-48 h-48 bg-white rounded-full opacity-10 blur-2xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center text-white mb-6">
            <h1 className="text-5xl font-bold mb-3 drop-shadow-lg">Seaside Voucher Book</h1>
            <p className="text-xl max-w-3xl mx-auto drop-shadow-md">Your Passport to Seaside Savings - Physical voucher books for those who prefer traditional coupons</p>
          </div>
        </div>
      </section>

      {/* What is Seaside Voucher Book */}
      <section className="py-20 bg-gradient-to-b from-cyan-50 to-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">What is the Seaside Voucher Book?</h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              The Seaside Voucher Book is a <strong>FREE physical voucher book</strong> packed with dozens of money-saving offers for attractions, dining, shopping, and entertainment along the Lincolnshire coast. It's your perfect companion for exploring Skegness, Mablethorpe, Ingoldmells, Chapel St Leonards, and more!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
            <div>
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/408959b6ed6c93537f5c74d2e18f4721.jpeg" 
                alt="Seaside Voucher Book Cover" 
                className="w-full rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-book-open-line text-2xl text-orange-500"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Easy to Use</h3>
                  <p className="text-gray-600">Simply tear out the voucher you want to use and present it at participating businesses. It's that simple!</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-range-line text-2xl text-teal-500"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Wide Coverage</h3>
                  <p className="text-gray-600">Accepted at dozens of businesses across the entire Lincolnshire coast - from north to south</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-pound-circle-line text-2xl text-green-500"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Real Savings</h3>
                  <p className="text-gray-600">Save on everything from theme parks and zoos to restaurants, cafes, and local shops</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Pick Up the Voucher Book */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Why Pick Up the Voucher Book?</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              The physical voucher book offers unique benefits for your seaside holiday
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="bg-gradient-to-br from-cyan-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group"
              >
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6 shadow-md group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                  <i className={`${benefit.icon} text-3xl text-orange-500`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What's Inside Section */}
      <section className="py-20 bg-gradient-to-b from-cyan-50 to-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">What's Inside the Book?</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Dozens of money-saving vouchers across all categories
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {categories.map((category, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group cursor-pointer"
              >
                <div className={`w-20 h-20 ${category.color} rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 group-hover:rotate-6 transition-all duration-300`}>
                  <i className={`${category.icon} text-4xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">{category.title}</h3>
                <p className="text-gray-600 text-center text-sm">{category.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pickup Locations */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Where Can I Pick Up My Free Copy?</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Starting Easter 2025, pick up your FREE Seaside Voucher Book at participating holiday parks, caravan parks, camping sites, and hotels throughout the Lincolnshire coast
            </p>
          </div>

          <div className="max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-8 md:p-12 rounded-3xl shadow-xl">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mb-8">
                {pickupLocations.map((location, index) => {
                  const gradients = [
                    'bg-gradient-to-br from-orange-50 to-orange-100',
                    'bg-gradient-to-br from-cyan-50 to-cyan-100',
                    'bg-gradient-to-br from-green-50 to-green-100',
                    'bg-gradient-to-br from-purple-50 to-purple-100',
                    'bg-gradient-to-br from-orange-50 to-orange-100',
                    'bg-gradient-to-br from-cyan-50 to-cyan-100'
                  ];
                  const iconColors = [
                    'text-orange-500',
                    'text-cyan-500',
                    'text-green-500',
                    'text-purple-500',
                    'text-orange-500',
                    'text-cyan-500'
                  ];
                  const textColors = [
                    'text-gray-900',
                    'text-gray-900',
                    'text-gray-900',
                    'text-gray-900',
                    'text-gray-900',
                    'text-gray-900'
                  ];
                  return (
                    <div 
                      key={index}
                      className={`${gradients[index % gradients.length]} p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 text-center`}
                    >
                      <i className={`${location.icon} text-4xl ${iconColors[index % iconColors.length]} mb-3`}></i>
                      <p className={`font-bold ${textColors[index % textColors.length]}`}>{location.name}</p>
                    </div>
                  );
                })}
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">Available at:</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
                  <div className="flex items-center gap-3">
                    <i className="ri-home-smile-line text-2xl text-orange-500"></i>
                    <span className="font-semibold">Holiday Parks</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-building-line text-2xl text-teal-500"></i>
                    <span className="font-semibold">Hotels</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-tent-line text-2xl text-green-500"></i>
                    <span className="font-semibold">Caravan Sites</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-compass-line text-2xl text-cyan-500"></i>
                    <span className="font-semibold">Camping Grounds</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-store-line text-2xl text-amber-500"></i>
                    <span className="font-semibold">Tourist Information Centers</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-community-line text-2xl text-pink-500"></i>
                    <span className="font-semibold">Local Businesses</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* App Download Section */}
      <section className="py-20 bg-gradient-to-br from-blue-500 to-blue-600 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-40 h-40 bg-white rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Prefer Digital?</h2>
            <p className="text-xl text-white/90 mb-10">
              Get the Seaside Vouchers app for instant access to all offers on your phone!
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <a 
                href="https://apps.apple.com/pk/app/seaside-vouchers-user/id6745555629" 
                target="_blank" 
                rel="noopener noreferrer"
                className="cursor-pointer transition-transform hover:scale-105"
              >
                <img 
                  src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1726012800" 
                  alt="Download on the App Store" 
                  className="h-14"
                />
              </a>
              <a 
                href="https://play.google.com/store/apps/details?id=com.jeuxdevelopers.SeasideUser&pcampaignid=web_share&pli=1" 
                target="_blank" 
                rel="noopener noreferrer"
                className="cursor-pointer transition-transform hover:scale-105"
              >
                <img 
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
                  alt="Get it on Google Play" 
                  className="h-14"
                />
              </a>
            </div>
            <p className="text-white/90 mt-6">Available now - FREE download with no subscription required!</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-cyan-500 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/659671df2896ffc0ce475e0437197503.png" 
                alt="Seaside Vouchers" 
                className="h-20 w-20 transform hover:scale-110 transition-transform duration-300"
              />
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/e0d98287e8c9dc8abdecc58291257ecc.png" 
                alt="SEASIDE VOUCHERS" 
                className="h-10"
              />
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Quick Link</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Home</Link></li>
                <li><Link to="/how-it-works" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">How it works</Link></li>
                <li><Link to="/seaside-offers" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Seaside offers</Link></li>
                <li><Link to="/voucher-book" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Voucher Book</Link></li>
                <li><Link to="/leisure-home-sales" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Leisure Home Sales</Link></li>
                <li><Link to="/accommodation" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Accommodation</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Company</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="https://seasidevouchers.co.uk/privacy-policy/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Privacy &amp; cookie policy</a></li>
                <li><a href="https://seasidevouchers.co.uk/terms-conditions/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">T&amp;C</a></li>
                <li><Link to="/contact" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Contact us</Link></li>
                <li><Link to="/business-registration" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Add Your Business</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Follow Us</h4>
              <div className="flex gap-4">
                <a href="https://www.facebook.com/people/seasidevouchers/61566031950810/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="https://www.instagram.com/seaside_vouchers/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="https://www.tiktok.com/@seasidevouchers" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-tiktok-fill text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-6 text-center text-sm">
            <p>Copyright © 2023 Seaside Voucher, All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
